// New design system component: centered empty state with icon circle, copy, and optional action

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function EmptyState({ icon, title, description, action }) {
  return (
    <MDBox py={6.5} px={2.5} textAlign="center">
      <MDBox
        width="3.25rem"
        height="3.25rem"
        mx="auto"
        mb={1.75}
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={({ palette: { background, text } }) => ({
          borderRadius: "50%",
          backgroundColor: background.default,
          color: text.muted,
        })}
      >
        <Icon sx={{ fontSize: "1.625rem !important" }}>{icon}</Icon>
      </MDBox>
      <MDTypography variant="h6" fontWeight="medium" sx={{ fontSize: "0.906rem", mb: 0.5 }}>
        {title}
      </MDTypography>
      {description && (
        <MDTypography
          variant="button"
          display="block"
          sx={({ palette: { text } }) => ({ color: text.main, mb: action ? 2 : 0 })}
        >
          {description}
        </MDTypography>
      )}
      {action}
    </MDBox>
  );
}

EmptyState.defaultProps = {
  icon: "inbox",
  description: null,
  action: null,
};

EmptyState.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  action: PropTypes.node,
};

export default EmptyState;
